import { Group, TextInput, Modal, Text, Center, Title, Button } from '@mantine/core';
import { IconBadgeVr, IconSearch, IconGridDots } from '@tabler/icons-react';
import React from 'react';
import DataTable from 'react-data-table-component';
import UserRow from './components/UserRow';
import { useNavigate } from "react-router-dom";
import useGetUser from "./useGetUser";
import LoadingErrorContainer from '../../components/placeholders/LoadingErrorContainer';
import ActionCell from './components/ActionCell';
import { exportUsers } from '../../api/user';

const Remote = () => {
    const navigate = useNavigate();
    const { themeQuery: {
        data, isPending, isError, isRefetching },
        totalRows,
        handleChangePerPage,
        handlePageChange,
        search,
        setSearch,
        queryKey
    } = useGetUser()

    console.log({ data });

    const columns = [
        {
            name: 'First Name',
            selector: row => row.tiktok_username ?? 'N/A',
            sortable: true,
            cell: row => <UserRow row={row} />,
            width: "200px",
        },

        {
            name: 'Email',
            selector: row => <Group>

                {row.email ?? 'N/A'}

                {((row.is_email_verified == true) ? <IconBadgeVr size={22} color='green' /> : "")}
            </Group>
            ,
            width: "300px",

            sortable: true,
        },
        {
            name: 'Agency Code',
            selector: row => row.agency_code ?? 'N/A',
            sortable: true,
        },
        {
            name: 'Country',
            selector: row => row.country,
            sortable: true,
        },
        {
            name: 'Language',
            selector: row => row.lang,
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => <ActionCell row={row} queryKey={queryKey} />,
            width: "300px",

        },
    ];

    const handleClick = async () => {
        try {
            // Call the `exportUsers` API function
            const response = await exportUsers();

            if (response?.data?.filename) {
                const url = response.data.filename;

                // Create an anchor element to trigger the download
                const anchor = document.createElement('a');
                anchor.href = url;
                anchor.download = 'users.xlsx'; // Suggest a filename
                anchor.click();
            } else {
                console.error('No filename returned in the response.');
            }
        } catch (error) {
            console.error('Error exporting users:', error);
        }
    };



    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Title order={3}>Users</Title>
                <Group>
                    <TextInput type='search' defaultValue={search} onChange={(event) => setSearch(event?.target?.value)} placeholder='Search' leftSection={<IconSearch size={18} />} style={{ alignSelf: "flex-end" }} />
                    <Button
                        onClick={handleClick}
                        variant="gradient"
                        gradient={{ from: '#44FFFA', to: '#FF4267', deg: 90 }}
                        leftSection={<IconGridDots style={{ width: '1rem', height: '1rem', alignSelf: "flex-end" }} />}

                    >Export Users </Button>
                </Group>

            </Group>
            <DataTable
                columns={columns}
                data={data?.data ?? []}
                progressPending={isPending}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handleChangePerPage}
                onChangePage={handlePageChange}

            // selectableRows

            />
        </LoadingErrorContainer>
    );
};


export default Remote
